import { Box, Chip, Grid, Paper, Typography } from "@mui/material";
import { UserIntegrationsContext } from "contexts/UserIntegrations";
import { useContext } from "react";

import StyledLink from "components/Styled/Link";

import GoogleConnect from "../GoogleConnect";
import styles from "./styles";

const Integrations = () => {
  const { userIntegration } = useContext(UserIntegrationsContext);
  return (
    <>
      <Typography variant="h4" gutterBottom>
        Integrations
      </Typography>

      <Paper
        variant="outlined"
        sx={{
          p: 3,
          borderRadius: 2,
          display: { xs: "auto", md: "flex" },
          alignItems: "center",
          justifyContent: { xs: "auto", md: "space-between" },
          gap: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
          <Box sx={styles.googleBrandContainer}>
            <Box
              component="i"
              className="fa-brands fa-google"
              sx={{ color: "green.main" }}
            />{" "}
          </Box>
          <Box>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}
            >
              <Typography variant="subtitle1" fontWeight={600}>
                Google
              </Typography>
              <Chip
                label={userIntegration?.email ? "Connected" : "Not connected"}
                icon={
                  <Box
                    sx={{
                      ml: "6px !important",
                    }}
                    component="i"
                    className={
                      userIntegration?.email
                        ? "fa-regular fa-check"
                        : "fa-solid fa-warning"
                    }
                  />
                }
                sx={{
                  backgroundColor: userIntegration?.email
                    ? "primary.main"
                    : "red.main",
                  color: userIntegration?.email ? "#bbf7d0" : "error.main",
                  fontWeight: 600,
                  fontSize: 14,
                  "& .MuiChip-icon": {
                    mr: 0,
                    color: userIntegration?.email ? "#bbf7d0" : "error.main",
                  },
                  px: 1,
                }}
              />
            </Box>
            {userIntegration?.email ? (
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.75,
                  mb: 0.5,
                  px: 1.25,
                  py: 0.5,
                  borderRadius: 1,
                  bgcolor: "grey.100",
                  border: "1px solid",
                  borderColor: "grey.300",
                  my: 3,
                }}
              >
                <Box
                  component="i"
                  className="fa-regular fa-envelope"
                  sx={{ fontSize: 13, color: "text.secondary" }}
                />
                <Typography
                  variant="body2"
                  fontWeight={500}
                  color="text.primary"
                >
                  Sending email from: {userIntegration.email}
                </Typography>
              </Box>
            ) : (
              <Typography sx={{ my: 2 }}>
                Connect your Gmail to send emails from Bento.
              </Typography>
            )}
            {userIntegration?.email && (
              <Typography sx={{ display: "block", mb: 0.5 }}>
                Connecting a new account will cancel outstanding follow-ups and
                reassign all scheduled emails.{" "}
                <strong>This cannot be undone.</strong>
              </Typography>
            )}
            <Typography variant="caption" color="text.secondary">
              You can revoke access at any time.{" "}
              <StyledLink
                href="https://support.google.com/accounts/answer/3466521?hl=en"
                target="_blank"
              >
                Manage your Google access.
              </StyledLink>
            </Typography>
          </Box>
        </Box>
        <Grid item xs={12} md="auto" sx={{ mt: { xs: 3, md: 0 } }}>
          <GoogleConnect />
        </Grid>
      </Paper>
    </>
  );
};

export default Integrations;
